/* tslint:disable */
/* eslint-disable */
/**
 * CMS Content Model
 * This OpenAPI specification describes the content model of the CMS. This specification does not describe a micro service, as can be imagined due to the fact that the are no operations defined. Instead, this specification defines schemas, that may be used   * to be referenced in service   * to validate content objects against schemas   * to generate forms   * many more... Each schema is specified within it\'s own file. This approach has been chosen to facilitate reuse and lucidity. This all-in-one specification is provided for convenience.
 *
 * The version of the OpenAPI document: 0.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Enumeration listing all icons referenceable by name.
 */
export const CmsIcons = {
    App: 'app',
    ArrowBreadcrumb: 'arrowBreadcrumb',
    ArrowLeft: 'arrowLeft',
    ArrowRight: 'arrowRight',
    BabyBottle: 'babyBottle',
    Beaker: 'beaker',
    Bin: 'bin',
    Blog: 'blog',
    Calendar: 'calendar',
    CaretDown: 'caretDown',
    CaretLeft: 'caretLeft',
    CaretRight: 'caretRight',
    CaretUp: 'caretUp',
    Cart: 'cart',
    Certificate: 'certificate',
    CircleCross: 'circleCross',
    CircleEuro: 'circleEuro',
    CircleExclamation: 'circleExclamation',
    CircleHealth: 'circleHealth',
    CircleInfo: 'circleInfo',
    CirclePlay: 'circlePlay',
    CircleStar: 'circleStar',
    CircleStarFilled: 'circleStarFilled',
    CircleTick: 'circleTick',
    Clock: 'clock',
    ContactLenses: 'contactLenses',
    Cross: 'cross',
    Delivery: 'delivery',
    Dispenser: 'dispenser',
    Document: 'document',
    DocumentChecklist: 'documentChecklist',
    DocumentInsert: 'documentInsert',
    DocumentMultimedia: 'documentMultimedia',
    Email: 'email',
    EmailArrow: 'emailArrow',
    Equals: 'equals',
    ERxPhone: 'eRxPhone',
    Euro: 'euro',
    ExtraRedpoints: 'extraRedpoints',
    Eye: 'eye',
    EyeCross: 'eyeCross',
    Facebook: 'facebook',
    Gift: 'gift',
    Hamburger: 'hamburger',
    HealthCross: 'healthCross',
    Heart: 'heart',
    HeartFilled: 'heartFilled',
    Home: 'home',
    HomeTo: 'homeTo',
    Leaf: 'leaf',
    Location: 'location',
    LocationHome: 'locationHome',
    LocationMap: 'locationMap',
    Lock: 'lock',
    Mail: 'mail',
    Message: 'message',
    Minus: 'minus',
    New: 'new',
    Notification: 'notification',
    Ods: 'ods',
    PackageList: 'packageList',
    PackagePrice: 'packagePrice',
    Paw: 'paw',
    Pdf: 'pdf',
    Pencil: 'pencil',
    Pills: 'pills',
    Pinterest: 'pinterest',
    Plus: 'plus',
    Prize: 'prize',
    Profile: 'profile',
    Redpoints: 'redpoints',
    Refresh: 'refresh',
    Search: 'search',
    SendEnvelope: 'sendEnvelope',
    Share: 'share',
    ShareAlt: 'shareAlt',
    Smartphone: 'smartphone',
    Smiley: 'smiley',
    StarEmpty: 'starEmpty',
    StarFilled: 'starFilled',
    Target: 'target',
    Telephone: 'telephone',
    Tick: 'tick',
    Twitter: 'twitter',
    Youtube: 'youtube'
};
